// import packages
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Breadcrumb, Popover } from 'antd';
import { Link, useNavigate, useParams } from 'react-router-dom';

// Import assets
import "./floor-details.scss"
import { Print_Icon, Share_Icon } from "../../assets/images";

// Import Components
// import MetaTags from "../../components/MetaTags";

// Import utils
import { getPropsFromState } from "../../redux/mapStateToProps";
import { GetFloorById, GetBuildingByIdOrSlug, GetBadges } from "../../redux/actions";
import { getUrlWithLocal } from "../../utils/getUrlWithLocal";
import {
    AREA_REDIRECT_TYPES,
    AREA_TYPES,
    BUILDINGS_SLUG,
    floorsImages,
    floorsSelect,
} from "../../constants/constants";
import { ACCEPT_BADGE_TYPES } from "../../constants/acceptedConsts";
import Subscription from "../../components/subscription/Subscription";
import MouseTracker from "../../components/MouseTracker";
// import {
//     FacebookIcon,
//     FacebookShareButton,
//     LinkedinIcon,
//     LinkedinShareButton,
//     TwitterIcon,
//     TwitterShareButton
// } from "react-share";
import { DetailsHeader } from "../../components/ui-elements/DetailsHeader";
import CallModel from "../../components/modal/callModel/CallModel";

// import AddressWrapper from "../../components/AddressWrapper/AddressWrapper";


function FloorDetails (props) {
    const componentRef = useRef();
    const [update, setUpdate] = useState(1)
    const [isHouseInfoVisible, setHouseInfoVisible] = useState(false)
    const [callModelOpen, setCallModelOpen] = useState(false)
    const [housesInfo, setHousesInfo] = useState({})
    const [floor, setFloor] = useState(null)
    const params = useParams()
    const navigate = useNavigate();

    const { buildingById, badges, staticTexts, selectedLanguage, contact } = props


    const toggleCallBtn = () => {
        setCallModelOpen(!callModelOpen)
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        window.addEventListener('resize', render)
        return () => {
            window.removeEventListener('resize', render)
        }
    }, [])

    useEffect(() => {
        props.GetBadges()
    }, [selectedLanguage])

    useEffect(() => {
        initFloorData()
    }, [params.num, selectedLanguage])

    useEffect(() => {
        const items = floor?.areas;
        items && items?.length && items?.map(item => {
            if (document.getElementById(item?.areaNumber)) {
                document.getElementById(item?.areaNumber)?.addEventListener("mouseenter", onMouseEnter.bind(null, item));
                document.getElementById(item?.areaNumber)?.addEventListener("mouseleave", onMouseLeave.bind(null, item))
                document.getElementById(item?.areaNumber)?.addEventListener("click", onClick.bind(null, item))
                document.getElementById(item?.areaNumber).style.stroke = item?.badge?.color;
                document.getElementById(item?.areaNumber).style.fill = item?.badge?.color;

                if (item?.badge?.id === ACCEPT_BADGE_TYPES?.FOR_SALE) {
                    document.getElementById(item?.areaNumber).style.stroke = item?.badge?.color;
                    document.getElementById(item?.areaNumber).style.fill = item?.badge?.color;
                }
            }
        })
/*        return () => {
            const items = floor?.areas;
            items && items?.length && items?.map(item => {
                if (document.getElementById(item?.areaNumber)) {
                    console.log('remove lisener')
                    document.getElementById(item?.areaNumber)?.removeEventListener("mouseenter", onMouseEnter.bind(null, item));
                    document.getElementById(item?.areaNumber)?.removeEventListener("mouseleave", onMouseLeave.bind(null, item))
                    document.getElementById(item?.areaNumber)?.removeEventListener("click", onClick.bind(null, item))
                }
            })
        }*/
    }, [floor?.id])

    async function initFloorData () {
        console.log('initFloorData')
        // const buildingData = !buildingById ? await props.GetBuildingByIdOrSlug(BUILDINGS_SLUG) : buildingById
        const buildingData = await props.GetBuildingByIdOrSlug(BUILDINGS_SLUG);
        let floorId = buildingData?.floors?.length
            && buildingData?.floors?.find(item => item.number === +params.num)?.id
        if (floorId) {
            props.GetFloorById(floorId).then((floor) => {
                setFloor(floor);
            }).catch(() => {
                navigate(getUrlWithLocal('/home'))
            })
        } else {
            navigate(getUrlWithLocal('/home'))
        }
    }

    function render () {
        setUpdate(update + 1)
    }

    function onMouseEnter (area) {
        setHouseInfoVisible(true);
        setHousesInfo(area);
    }

    function onMouseLeave (area) {
        setHouseInfoVisible(false)
    }

    function onClickFloor (floor) {
        navigate(getUrlWithLocal(`/floor/${floor?.number}`))
    }

    function onClick (area) {
        let areaId = area.id;
        let floorNumber = params?.num;
        console.log('onclick', areaId, AREA_REDIRECT_TYPES[areaId] );
        if(AREA_REDIRECT_TYPES[areaId]){
            const obj=AREA_REDIRECT_TYPES[areaId]
            areaId = obj.id
            floorNumber = obj.floor
        }
        navigate(getUrlWithLocal(`/floor/${floorNumber}/place/${areaId}`))
    }

    const Svg = floorsSelect[`A1_${params?.num}`]

    const badgesAndConsultationJsx = <>
        <div className={'badges-wrapper'}>
            {badges && !!badges?.length && badges.map(item => {
                return <div className={'badge-item'} key={item?.id}>
                    <div className={'badge-color'} style={{ background: item.color }}/>
                    <div className={'color-text'}>{item?.title}</div>
                </div>
            })}
        </div>
        <div className={'consultation-wrapper'} onClick={() => setCallModelOpen(true)}>
            <div className={'text'}>
                {staticTexts?.house_consulting_text}
            </div>
            <div className={'button'}>{staticTexts?.house_consulting_btn}</div>
        </div>
    </>
    const breadCrumbList = [
        {
            url: '/home',
            title: staticTexts?.rout_item_home
        },
        {
            url: '/buildings',
            title: staticTexts?.rout_item_building
        },
        {
            title:`${staticTexts?.rout_item_floor} ${params.num}`
        },
    ]

    console.log(floor?.number,'floor?.number')

    return <div className={'FloorWrapper'}>
        {/*<MetaTags*/}
        {/*    title={`${staticTexts?.rout_item_floor} ${floor?.number}`}/>*/}
        <div className={'ContentWrapper'}>
            <DetailsHeader breadCrumbList={breadCrumbList}
            contact={contact}
                           staticTexts={staticTexts}/>
            <div className={"FloorMainContent"}>
                <div className={'LeftSide'} id="result-table">
                    <div className={'floors-main-wrapper'}>
                        <div
                            className={'selected-floor'}>{`${staticTexts?.rout_item_floor} ${floor?.number ? floor?.number : ''}`}{staticTexts?.house_out_of}{staticTexts?.house_out_of_number || '8'}
                        </div>
                        <div className={'divider'}/>

                        <div className={'floors-content'}>
                            <div className={'floors-title'}>{staticTexts?.house_floor_title}</div>
                            <div className={'floors-list'}>
                                {/*<div className={`mobile-parking-button ${floor?.number === -1 ? 'active' : '' }`}*/}
                                {/*     onClick={()=>{*/}
                                {/*         navigate(getUrlWithLocal(`/floor/-1`))*/}
                                {/*}}>{staticTexts?.house_parking_text}</div>*/}
                                {buildingById && !!buildingById?.floors?.length && buildingById?.floors?.slice(1).map(item => {
                                    return <div onClick={() => onClickFloor(item)}
                                                key={item?.id}
                                                className={`list-item ${item.number === floor?.number ? 'active' : (item.inactive ? 'inactive-floor' : '')}`}>{item?.number}</div>
                                })}
                            </div>
                            {/*<div className={'parking-wrapper'}>*/}
                            {/*    <div className={'parking-title'}>{staticTexts?.rout_item_title_parking}</div>*/}
                            {/*    <div className="parking-button" onClick={()=>{*/}
                            {/*        navigate(getUrlWithLocal(`/floor/-1`))*/}
                            {/*    }}>*/}
                            {/*        {staticTexts?.house_parking_text}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    {window.innerWidth > 1050 && badgesAndConsultationJsx}
                </div>
                <div className={'RightSide'}>
                    <div className={'RightInnerPart'}>
                        <div className={`ImageWrapper`} ref={componentRef}>
                            <img src={floorsImages[`A1_${params?.num}`]} alt={"building"}/>
                            {/* {params?.num < 0 ? !floor?.areas?.find(item => item?.badge?.id !== HOUSE_BADGES.sold.key)
                            : !!floor?.areas?.length && !floor?.areas?.find(item => item?.badge?.id !== HOUSE_BADGES.sold.key) &&
                            <img className="sold-item" src={SOLD_IMAGES?.[selectedLanguage?.code]} alt=""/>
                        }*/}
                            {floorsImages[`A1_${params?.num}`] && <Svg/>}
                            <MouseTracker
                                visible={isHouseInfoVisible}
                                offsetX={-10}
                                offsetY={30}
                            >
                                <div className={'floor-tooltip-wrapper'}>
                                    <div className={`tooltip-left-part `}
                                        // style={{ background: housesInfo?.badge?.color }}
                                    >
                                    <span className={'building-number'}>
                                        N {housesInfo.areaNumber}
                                    </span>
                                    </div>
                                    {params?.num > 0 && <div className={'tooltip-right-part'}>
                                    <span className={'floors-count'}>
                                        {housesInfo?.type !== AREA_TYPES.OFFICE.key && housesInfo?.roomsCount} {housesInfo?.type === AREA_TYPES.OFFICE.key ? staticTexts?.mouse_info_office : staticTexts?.mouse_info_room}
                                    </span>
                                        <span className={'houses-count'}>
                                            {`${housesInfo?.area} ${staticTexts?.measurement_unit_meter}`}<sup>2</sup>
                                        </span>
                                    </div>
                                    }
                                </div>
                            </MouseTracker>
                        </div>
                    </div>
                </div>
                {window.innerWidth <= 1050 && badgesAndConsultationJsx}
            </div>
        </div>
        <Subscription/>
        {
            callModelOpen && <CallModel callModelOpen={callModelOpen}
                                        staticTexts={staticTexts}
                                        toggleCallBtn={toggleCallBtn}/>
        }
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'contact',
    'about',
    'buildings',
    'buildingById',
    'badges',
    'areas',
    'selectedLanguage',
]);

const mapDispatchToProps = {
    GetFloorById,
    GetBuildingByIdOrSlug,
    GetBadges,
};

export default connect(mapStateToProps, mapDispatchToProps)(FloorDetails);
